/**
 * @author center
 * @date 2021/5/19-4:54 下午
 * @file m-type
 */

export const SET_MENU_OPEN = 'menu_open/set_menu_open';
